<template>
  <no-auth-layout :current-step="step < 5 ? step : null" @back="goBack">
    <div
      class="flex flex-col items-start w-full h-[90vh] pt-[32px] gap-2 px-5 relative md:max-w-[552px] md:mx-auto md:px-0"
    >
      <!-- STEP 1: Mobile Number Input -->
      <MobileNumberInput v-if="step === 1" @next="goToStep(2)" />

      <!-- STEP 2: Mobile OTP Verification -->
      <MobileOtpVerify
        v-if="step === 2"
        :country-code="mobileData.countryCode"
        :mobile-number="mobileData.mobileNumber"
        @next="goToStep(3)"
      />

      <!-- STEP 3: New Email Input -->
      <NewEmailInput v-if="step === 3" @next="goToStep(4)" />

      <!-- STEP 4: Email OTP Verification -->
      <EmailOtpVerify v-if="step === 4" :email="newEmail" @next="goToStep(5)" />

      <!-- STEP 5: Success Page -->
      <ResetEmailSuccess v-if="step === 5 && isEmailVerified" />
    </div>
  </no-auth-layout>
</template>
<script>
import EmailOtpVerify from '@/components/ForgotEmail/EmailOtpVerify.vue';
import MobileNumberInput from '@/components/ForgotEmail/MobileNumberInput.vue';
import MobileOtpVerify from '@/components/ForgotEmail/MobileOtpVerify.vue';
import NewEmailInput from '@/components/ForgotEmail/NewEmailInput.vue';
import ResetEmailSuccess from '@/components/ForgotEmail/ResetEmailSuccess.vue';
import NoAuthLayout from '@/components/NoAuth.vue';
import { mapState } from 'vuex';

export default {
  components: {
    NoAuthLayout,
    MobileNumberInput,
    MobileOtpVerify,
    NewEmailInput,
    EmailOtpVerify,
    ResetEmailSuccess,
  },
  computed: {
    ...mapState('forgotCredentials', [
      'step',
      'mobileData',
      'mobileOtp',
      'newEmail',
      'emailOtp',
      'isEmailVerified',
    ]),
  },
  methods: {
    goToStep(stepNumber) {
      this.$store.commit('forgotCredentials/setStep', stepNumber);
    },
    goBack() {
      if (this.step > 1) {
        this.$store.commit('forgotCredentials/setStep', this.step - 1);
      } else {
        this.$router.push('/login');
      }
    },
  },
};
</script>
